<template>
  <div class="common-warp">
    <div class="common-container">
      <div v-if="contentNone" class="div-layout text-div pd0">
        <div class="breadcrumb">
          <router-link :to="{ name: 'Home'}">
            首页
          </router-link> > {{ propsTitile }}
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Common',
  components: {
  },
  props: {
    propsTitile: {
      type: String,
      default: ''
    },
    contentNone: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.common-warp{
  .common-container{
    background-color: #f0f2f5;
    margin-top: 20px;
  }
  .breadcrumb{
    padding: 20px 40px;
    border-bottom: 1px solid #f4f4f4;
  }
}
</style>

